<template>
    <div>
        <v-btn class="normal-btn" :block="block" :color="color" depressed @click="$refs.confirm.show()">
            <v-icon v-if="icon" left>{{ icon }}</v-icon>
            {{ label }}
        </v-btn>
        <kimsa-confirm
            ref="confirm"
            :title="title"
            :content="content"
            :loading="loading"
            :persistent="false"
            @confirm="$emit('confirm')"
            :close-on-confirm="false"
            :alert-mode="alertMode"
        />
    </div>
</template>

<script>
import KimsaConfirm from "@/components/common/KimsaConfirm";
export default {
    name: "ConfirmButton",
    components: {KimsaConfirm},
    props: {
        block: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        },
        content: {
            type: String,
            default: ''
        },
        loading: {
            type: Boolean,
            default: false
        },
        alertMode: {
            type: Boolean,
            default: false
        },
    },
    methods: {
        hide() {
            const vm = this
            vm.$refs.confirm.hide()
        },
    }
}
</script>

<style scoped>

</style>